import React from "react";
import { brandCodeViewTheme, CodeView } from "components/CodeView";
import { useFeatureSwitch } from "components/FeatureSwitch";
import { EditorView } from "@codemirror/view";
import { analyticsCodeViewTheme } from "utils/analytics/themes";

interface RequestCodeViewProps {
  requestText: string;
  onClick: (e: React.MouseEvent) => void;
}

const RequestCodeView: React.FC<RequestCodeViewProps> = ({
  requestText,
  onClick,
}) => {
  const isRebrand = useFeatureSwitch("REACT_APP_USE_REBRAND_2026");

  return (
    <div className="cursor-pointer" onClick={onClick}>
      <div className="rounded overflow-hidden">
        <div className="w-full dark:border dark:border-gray-200">
          <CodeView
            language="text"
            content={requestText}
            minHeight="5rem"
            maxHeight="10rem"
            theme={isRebrand ? brandCodeViewTheme : analyticsCodeViewTheme}
            basicSetup={{
              lineNumbers: true,
              foldGutter: false,
              dropCursor: false,
              allowMultipleSelections: false,
              indentOnInput: false,
              bracketMatching: true,
              closeBrackets: false,
              autocompletion: false,
              rectangularSelection: false,
              highlightSelectionMatches: false,
              searchKeymap: false,
            }}
            editable={false}
            extensions={[EditorView.lineWrapping]}
          />
        </div>
      </div>
    </div>
  );
};

export default RequestCodeView;
